import { useQuery } from '@tanstack/react-query';

import {
  FetchKybsRequest,
  FetchKybsResponse,
  individualsService,
  kybService,
} from '@aslanpay/portal-common-lib';

const useFetchKybPage = ({ ids, status, query, sortBy, sort, page, size }: FetchKybsRequest) => {
  return useQuery<FetchKybsResponse, Error>(
    ['fetchKybsPage', ids, status, page, size, query, sortBy, sort],
    async () => {
      const kybs = await kybService.fetchKybs({
        ids,
        status,
        page,
        size,
        query,
        sortBy,
        sort,
      });

      const individualIds = kybs.list
        .map((kyb) => kyb.approvedBy || kyb.declinedBy)
        .filter((id) => id !== undefined);

      if (individualIds.length === 0) {
        return { ...kybs };
      }

      const individuals = await individualsService.fetchIndividuals({
        ids: individualIds,
        page: 0,
        size: 999999,
      });

      const kybsList = kybs.list.map((kyb) => {
        const approvedByIndividual = individuals.list.find((ind) => ind.id === kyb.approvedBy);
        const declinedByIndividual = individuals.list.find((ind) => ind.id === kyb.declinedBy);

        return {
          ...kyb,
          approvedByName: approvedByIndividual
            ? `${approvedByIndividual.firstName} ${approvedByIndividual.lastName}`
            : 'undefined',
          declinedByName: declinedByIndividual
            ? `${declinedByIndividual.firstName} ${declinedByIndividual.lastName}`
            : 'undefined',
        };
      });

      return { ...kybs, list: kybsList };
    }
  );
};

export default useFetchKybPage;
